import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

const PartnerSharesHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <h6 className="overline-title-alt mb-2">{t('ParticipationDetail')}</h6>
  );
};

export default PartnerSharesHeader;
